// extracted by mini-css-extract-plugin
export default {"root":"CheckboxWithLabel_root__3M-E4","label":"CheckboxWithLabel_label__yy3c9"};